var map = {
	"./bruecke.jpeg": 5855,
	"./bruecke2.jpeg": 6671,
	"./bruecke2.jpg": 2098,
	"./drohne.jpeg": 6840,
	"./flagge.jpeg": 4270,
	"./nova.jpeg": 9646,
	"./oleshky.jpg": 5328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8235;